import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import {
  typeOfState,
  typesOfElement
} from '@white-label-configuration/constants';
import DotsLoader from '../dots-loader/dots-loader.vue';

/**
 * @deprecated Please use cavu-button if you are using this as a button
 */

interface ControlButtonProps {
  id?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  typeOfElement: keyof typeof typesOfElement;
  buttonType: keyof typeof typeOfState;
  to?: () => void
  loading?: boolean;
  disabled?: boolean;
  isContentCentered?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'control-button',
  props: {
    id: { default: '' },
    type: { default: undefined },
    typeOfElement: null,
    buttonType: null,
    to: { type: Function, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isContentCentered: { type: Boolean, default: false }
  },
  emits: ['mounted', 'btnClick'],
  setup(__props: any, { emit }) {

const props = __props as { id: string, type: 'submit' | 'reset' | 'button' | undefined, typeOfElement: keyof typeof typesOfElement, buttonType: keyof typeof typeOfState, to: () => void, loading: boolean, disabled: boolean, isContentCentered: boolean };





const getTypeOfStateClass = computed(() =>
  props.buttonType ? `button-${props.buttonType}` : ''
);

const getEnvClass = computed(() => {
  const { NUXT_ENV_THEME } = process.env;
  return NUXT_ENV_THEME ? `button-${NUXT_ENV_THEME}` : '';
});

const getDisabledState = computed(() =>
  props.disabled ? `button-${props.buttonType}--disabled` : ''
);

const getJustifyClass = computed(() =>
  !props.isContentCentered && !props.loading ? 'justify-between' : 'justify-center'
);

const typeIsButton = computed(() => props.typeOfElement === typesOfElement.button);
const typeIsLink = computed(() => props.typeOfElement === typesOfElement.link);

onMounted(() => {
  if (typeIsLink.value && !props.to) {
    throw new Error(
      'If typeOfElement === "link", prop "to" must contain value'
    );
  }
  emit('mounted');
});

return { __sfc: true,props, emit, getTypeOfStateClass, getEnvClass, getDisabledState, getJustifyClass, typeIsButton, typeIsLink, DotsLoader }
}

})